<template>
    <div class="payment-detail">
        <div class="mb-3">
            <div class="payment-detail-row">
                <div class="payment-detail-title">
                    <b>Payment ID</b>
                </div>
                <div class="payment-detail-content">
                    {{paymentDetails.paymentIdShort}}
                </div>
            </div>

            <template v-if="paymentSummary.isPaid">
                <div class="payment-detail-row">
                    <div class="payment-detail-title">
                        <b>Payment Status</b>
                    </div>
                    <div class="payment-detail-content">
                        Paid
                    </div>
                </div>

                <div class="payment-detail-row">
                    <div class="payment-detail-title">
                        <b>Payment Date</b>
                    </div>
                    <div class="payment-detail-content">
                        {{paymentDateTimeParsed}}
                    </div>
                </div>
            </template>

            <div class="payment-detail-row">
                <div class="payment-detail-title">
                    <b>Payment Amount</b>
                </div>
                <div class="payment-detail-content">
                    RM {{paymentSummary.paymentAmount.toFixed(2)}}
                </div>
            </div>
            <div class="payment-detail-row payment-detail-topdown">
                <div class="payment-detail-title">
                    <b>Payment Summary</b>
                </div>
                <div>
                    <div class="payment-detail-content">
                        <table class="table table-bordered table-sm">
                            <colgroup>
                                <col width="70">
                                <col>
                                <col width="130">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Item</th>
                                    <th scope="col" class="text-right">Price (RM)</th>
                                </tr>
                            </thead>
                            <tbody v-for="(item, index) in paymentSummary.summaryItems" :key="index">
                                <tr>
                                    <th scope="row">{{index+1}}</th>
                                    <td>{{item.itemName}} {{ item.itemDescription ? `- ${item.itemDescription}` : null }}</td>
                                    <td class="text-right">{{item.itemPrice.toFixed(2)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <th colspan="2" scope="row" class="text-right">Total (RM)</th>
                                <td class="text-right">
                                    {{paymentSummary.paymentAmount.toFixed(2)}}
                                </td>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!paymentSummary.isPaid" class="mb-3">
            <p>My credit balance balance: <b>RM {{wallet.amount.toFixed(2)}}</b></p>

            <div class="mb-3">
                <div class="form-check">
                    <label class="form-check-label d-flex align-items-center">
                        <input class="form-check-input" type="checkbox" v-model="paymentForm.shouldUseWallet">
                        <span>Use my credit balance to pay</span>
                    </label>
                </div>
            </div>

            <form data-vv-scope="offsetPaymentForm"  @submit.prevent="validateOffsetWallet">
                <div v-if="shouldUseWallet" class="form-group row">
                    <label class="col-sm-3 col-form-label">Deduct Credit Balance</label>
                    <div class="col-sm-9">
                        <input ref="walletOffsetInput" name="walletOffsetAmount" type="text" data-vv-validate-on="blur"
                            data-vv-as="deduct credit balance" v-validate="walletOffsetValidation"
                            v-model="paymentForm.walletOffsetAmount" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('offsetPaymentForm.walletOffsetAmount')
                                        }">
                        <div v-show="validationErrors.has('offsetPaymentForm.walletOffsetAmount')" class="invalid-feedback">
                            {{ validationErrors.first('offsetPaymentForm.walletOffsetAmount') }}
                        </div>
                    </div>
                </div>
            </form>

            <div style="display: none;">
                <form ref="insvPayment" method="post" :action="paymentSubmitPath">
                    <input type="text" name="UseWallet" v-model="paymentForm.shouldUseWallet" />
                    <input type="text" name="PaymentWalletAmount"  v-model="paymentForm.walletOffsetAmount" />
                    <input type="text" name="PaymentSummaryId"  v-model="paymentSummary.paymentSummaryId" />
                    <input type="text" name="PaymentRemarks"  v-model="paymentDetails.paymentRemarks" />
                    <input name="Token" v-model="token" type="hidden">
                </form>
            </div>
        </div>

        <!-- <div v-if="!paymentSummary.isPaid" class="payment-detail-row payment-detail-topdown">
            <div><b>Payment Disclaimer</b></div>
            <p>Payment Disclaimer Here (Please confirm your appointment date and time. To protect the mutual interest between the individual and the doctor, you are not allowed to cancel the appointment once the payment is confirmed. Request to refund on failed appointments will be upon the discretion of InsureSavvy Sdn. Bhd.)</p>
            <button @click="payNow" class="btn btn-primary btn-primary-insv">Agree and Pay Now</button>
        </div> -->

        <slot></slot>
    </div>
</template>

<script>
import {
    apiPath
} from '@/config';
import userAppointmentStatus from '@/components/appointment-status/user';
import {
    convertToUserReadableDateTime
} from '@/utilities';
import Cookies from 'js-cookie';
export default {
    'name': 'PaymentDetail',
    'components': {
        userAppointmentStatus
    },
    'props': {
        'paymentDetails': {
            'type': Object
        },
        'paymentSummary': {
            'type': Object
        }
    },
    'watch': {
        shouldUseWallet (val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.walletOffsetInput.select();
                });
            }
        }
    },
    data () {
        return {
            'paymentForm': {
                'shouldUseWallet': false,
                'walletOffsetAmount': 0,
                'paymentSummaryId': ''
            },
            'wallet': {
                'amount': 0
            }
        };
    },
    mounted () {
        this.axios.get('Wallet/GetMyWallet').then(({
            data
        }) => {
            if (data.data) {
                this.wallet.amount = data.data.a;
            }
        });
    },
    'computed': {
        paymentDateTimeParsed () {
            if (this.paymentSummary && this.paymentSummary.isPaid) {
                return this.paymentDetails.completedDate ? convertToUserReadableDateTime(this.paymentDetails
                    .completedDate) : '-';
            } else {
                return '-';
            }
        },
        shouldUseWallet () {
            return this.paymentForm.shouldUseWallet;
        },
        walletOffsetValidation () {
            let paymentAmountMaxValidate = this.paymentSummary ? `|max_value:${this.paymentSummary.paymentAmount > this.wallet.amount ? this.wallet.amount : this.paymentSummary.paymentAmount}` : '';
            return `required|decimal:2|min_value:0.01|${paymentAmountMaxValidate}`;
        },
        paymentSubmitPath () {
            return `${apiPath}MakePayment/Pay`;
        },
        token () {
            return Cookies.get('t');
        }
    },
    'methods': {
        payNow () {
            this.$refs.insvPayment.submit();
        },
        validateOffsetWallet () {
            return this.$validator.validateAll('offsetPaymentForm');
        }
    }
};

</script>

<style>
    .payment-detail {}

    .payment-detail .payment-detail-row .payment-detail-title {
        margin-bottom: .25rem;
    }

    .payment-detail-topdown {}

    .payment-detail-topdown .payment-detail-title {
        margin-right: 1.25rem;
    }

    .payment-detail-content table {
        margin-bottom: 0;
    }

    @media(min-width: 576px) {
        .payment-detail .payment-detail-row:not(.payment-detail-topdown) {
            display: flex;
        }

        .payment-detail .payment-detail-row:not(.payment-detail-topdown) .payment-detail-title {
            width: 150px;
            margin-bottom: 0;
            margin-right: 1.25rem;
        }

        .payment-detail .payment-detail-row:not(.payment-detail-topdown) .payment-detail-content {
            display: flex;
            flex: 1;
        }
    }

    .payment-detail .payment-detail-row:not(:last-child) {
        margin-bottom: 1.25rem;
    }

    .payment-detail-content p:last-child {
        margin-bottom: 0;
    }

</style>
